import { apiClient } from "@/ultis/apiClient";
const controller = "wing-metfone-package";

const isTest = false;
export const actions = {
  async get({ commit }) {
    return apiClient.get(controller);
  },

  async getListPackage({ commit }, params) {
    return apiClient.post(controller + "/get-all", params);
  },
  async getDetailPackage({ commit }, params) {
    return apiClient.post(controller + "/get-service-detail", params);
  },
  async prePayment({ commit }, params) {
    return apiClient.post(controller + "/pre-payment", params);
  },

  async getRemark({ commit }, params) {
    return apiClient.post("wing-metfone-transaction/get-remark", params);
  },

  async transactionCallback({ commit }, params) {
    return apiClient.post(
      "wing-metfone-transaction/transaction-callback",
      params,
    );
  },

  async getListHistory({ commit }, params) {
    return apiClient.post(controller + "/get-histories", params);
  },



  async getListMyService({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              services: [
                {
                  serviceCode: "METFONE_DATA_1GB_1DAY",
                  serviceName: "Data 1GB / 1 Day",
                  subServiceName: "Data 1GB / 1 Day",
                  shortDes: "1GB data, valid for 1 day",
                  price: 10,
                  unit: "$",
                  validity: "1 day",
                  iconUrl: "https://via.placeholder.com/56",
                  renew: false,
                  expiredDate: "2026-05-25",
                },
                {
                  serviceCode: "METFONE_DATA_5GB_30DAY",
                  serviceName: "Data 5GB / 30 Days",
                  subServiceName: "Data 5GB / 30 Days",
                  shortDes: "5GB data, valid for 30 days",
                  price: 25,
                  unit: "$",
                  validity: "30 days",
                  iconUrl: "https://via.placeholder.com/56",
                  renew: false,
                  expiredDate: "2026-06-13",
                },
              ],
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("users/myServices", params);
  },

  async getCurrentUsedServiceDetail({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              services: [
                {
                  serviceCode: "METFONE_DATA_1GB_1DAY",
                  serviceName: "Data 1GB / 1 Day",
                  subServiceName: "Data 1GB / 1 Day",
                  packageStatus: "active",
                  statusLabel: "Active",
                  remainingData: "1GB",
                  remainingMinutes: "100 mins",
                  remainingSms: "50 SMS",
                  activationDate: "2026-05-24T08:00:00Z",
                  expiredDate: "2026-05-25T23:59:59Z",
                  fullDes:
                    "Remaining data: 1GB<br>Valid until: 25/05/2026<br>Call minutes: 100 mins<br>SMS: 50 SMS",
                  shortDes: "1GB data, valid for 1 day",
                  price: 10,
                  unit: "$",
                  validity: "1 day",
                  iconUrl: "https://via.placeholder.com/56",
                  renew: false,
                  errorCode: "0",
                },
                {
                  serviceCode: "METFONE_DATA_3GB_7DAY",
                  serviceName: "Data 3GB / 7 Days",
                  subServiceName: "Data 3GB / 7 Days",
                  packageStatus: "expired",
                  statusLabel: "Expired",
                  remainingData: "0MB",
                  remainingMinutes: "0 mins",
                  remainingSms: "0 SMS",
                  activationDate: "2026-05-18T08:00:00Z",
                  expiredDate: "2026-05-25T23:59:59Z",
                  fullDes:
                    "Package expired on 25/05/2026<br>Remaining data: 0MB<br>Call minutes: 0 mins<br>SMS: 0 SMS",
                  shortDes: "3GB data, valid for 7 days",
                  price: 20,
                  unit: "$",
                  validity: "7 days",
                  iconUrl: "https://via.placeholder.com/56",
                  renew: false,
                  errorCode: "1",
                },
                {
                  serviceCode: "METFONE_DATA_5GB_30DAY",
                  serviceName: "Data 5GB / 30 Days",
                  subServiceName: "Data 5GB / 30 Days",
                  packageStatus: "pending",
                  statusLabel: "Pending activation",
                  remainingData: "5GB",
                  remainingMinutes: "200 mins",
                  remainingSms: "100 SMS",
                  activationDate: "2026-05-26T08:00:00Z",
                  expiredDate: "2026-06-25T23:59:59Z",
                  fullDes:
                    "Package pending activation<br>Activation date: 26/05/2026<br>Data: 5GB<br>Call minutes: 200 mins<br>SMS: 100 SMS",
                  shortDes: "5GB data, valid for 30 days",
                  price: 35,
                  unit: "$",
                  validity: "30 days",
                  iconUrl: "https://via.placeholder.com/56",
                  renew: false,
                  errorCode: "2",
                },
              ],
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("users/myServices/detail", params);
  },

  async getISDN({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              subscriberInfo: {
                isdn: "85512345678",
                msisdn: "012345678",
                status: "active",
                simType: "Metfone",
                activationDate: "2026-05-01T08:00:00Z",
                expiredDate: "2027-05-01T08:00:00Z",
                customerName: "Nguyen Van A",
              },
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("users/isdn", params);
  },

  async buyPackage({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              transactionId: "TXN_MOCK_0001",
              paymentStatus: "SUCCESS",
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("packages/buy", params);
  },
  async genRequestId({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              requestId: "REQ_MOCK_123456",
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("transaction/gen-request-id", params);
  },

  async getHashPayment({ commit }, params) {
    if (isTest) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            code: "200",
            status: true,
            message: "Success",
            data: {
              errorCode: 0,
              hashPayment: "MOCK_HASH_PAYMENT_ABC123",
            },
          });
        }, 1000);
      });
    }
    return apiClient.post("metfoneServices/genHashDoPayment", params);
  },
};
